import React, { useEffect } from 'react';
// import SwitchLanguageAlert from '@/components/switch-language-alert';
import Footer from './components/Footer';
import BackTop from '@/components/back-top';
import HeaderNav from './components/header-nav';
import 'antd/dist/reset.css';
import '@styles/components.css';
import '@styles/nottas-test-awesome-project-te-a9620974.css';
import '@styles/core/index.less';
import useGoogleOneTap from '@/hooks/useGoogleOneTap';
import Head from '@/components/head';
import { TallyMessageWatcher, loadFont } from '@/utils';
import '@/init';
import initMcLogger from '@/init/init-mc-logger';
// import TopBanner, { TopBannerType } from './components/top-banner';

interface IProps {
  children?: React.ReactNode;
  isMediaTool?: boolean;
  isNewLayout?: boolean;
  isHomePage?: boolean;
  getNavBarHeight?: (value: number) => void;
}

const Layout: React.FC<IProps> = ({
  children,
  isMediaTool = false,
  isNewLayout = false,
  // isHomePage = false,
  getNavBarHeight,
}) => {
  // const [showSwitchLanguage, setShowSwitchLanguage] = useState(false);
  useGoogleOneTap();
  initMcLogger();

  // useEffect(() => {
  //   const browserLanguage = getUserBrowserLanguage();

  //   if (browserLanguage === 'en') {
  //     setShowSwitchLanguage(true);
  //   }
  // }, []);

  useEffect(() => {
    loadFont(
      'LINESeedJPStd',
      'normal',
      400,
      'https://cdn.jsdelivr.net/gh/mindcruiser/notta-official-website-font@v1.0.0/lineseedjp_otf_rg.woff2',
    );
    loadFont(
      'LINESeedJPStd',
      'normal',
      700,
      'https://cdn.jsdelivr.net/gh/mindcruiser/notta-official-website-font@v1.0.0/lineseedjp_otf_bd.woff2',
    );
    loadFont(
      'LINESeedJPStd',
      'normal',
      800,
      'https://cdn.jsdelivr.net/gh/mindcruiser/notta-official-website-font@v1.0.0/lineseedjp_otf_eb.woff2',
    );

    /**
     * 注册 tally postMessage 事件监听
     */
    window.addEventListener('message', TallyMessageWatcher.registerPostMessageHandle);
    return () => {
      window.removeEventListener('message', TallyMessageWatcher.registerPostMessageHandle);
    };
  }, []);

  return (
    <>
      <div className="w-embed" />
      <div id="page-anchor-top" className="page-anchor" />
      <Head htmlAttr={{ lang: 'ja' }} />
      {/* {isHomePage && showSwitchLanguage && (
        <TopBanner type={TopBannerType.switchLanguage} lsKey="switch-language-ls-key-11-24" />
      )} 
      <TopBanner lang="ja" type={TopBannerType.feature} lsKey="showcase-ls-key-02-07-ja" />
      */}
      {/* <TopBanner lang="ja" type={TopBannerType.senryuContest} lsKey="senryu-contest-ls-key-03-01-ja" /> */}
      {/* <SwitchLanguageAlert /> */}
      {/* <TopBanner type={TopBannerType.discount} lsKey="discount-ls-key-12-22-ja" /> */}
      <HeaderNav getNavBarHeight={getNavBarHeight} />
      {/* <Header isMediaTool={isMediaTool} isNewLayout={isNewLayout} /> */}
      {children}
      <BackTop />
      <Footer isMediaTool={isMediaTool} isNewLayout={isNewLayout} />
    </>
  );
};

export default Layout;
